var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSafePayment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.26,
    height: 26.2,
    viewBox: "0 0 26.26 26.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "security_icon",
    "data-name": "security icon",
    transform: "translate(-1490.997 -345.97)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10448",
    "data-name": "Path 10448",
    d: "M24.932,13.087v7.128a3.26,3.26,0,0,1-1.224,2.546L19.5,26.13l-4.211-3.369a3.259,3.259,0,0,1-1.224-2.546V13.087L19.5,12Z",
    transform: "translate(1484.63 340.548)",
    fill: "none",
    stroke: "#a4a9b8",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10449",
    "data-name": "Path 10449",
    d: "M25.5,21l-3.261,3.261-2.174-2.174",
    transform: "translate(1481.891 336.44)",
    fill: "none",
    stroke: "#a4a9b8",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10450",
    "data-name": "Path 10450",
    d: "M1.062,13.5A12.5,12.5,0,0,1,25.067,8.609",
    transform: "translate(1490.566 345.57)",
    fill: "none",
    stroke: "#a4a9b8",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10451",
    "data-name": "Path 10451",
    d: "M2.892,28.891A12.5,12.5,0,0,0,26.9,24",
    transform: "translate(1489.73 335.07)",
    fill: "none",
    stroke: "#a4a9b8",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10452",
    "data-name": "Path 10452",
    d: "M43.551,9.166l-1.056,3.171-3.258-.792",
    transform: "translate(1473.137 341.842)",
    fill: "none",
    stroke: "#a4a9b8",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10453",
    "data-name": "Path 10453",
    d: "M.949,36.17,2,33l3.258.792",
    transform: "translate(1490.617 330.961)",
    fill: "none",
    stroke: "#a4a9b8",
    strokeWidth: 1.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafePayment);
export default __webpack_public_path__ + "static/media/safe-payment.b683317b4d5db6418aa4569bab4a6a24.svg";
export { ForwardRef as ReactComponent };